import { Flex, ProductColor, Typography, TypographyProps } from '@aloft/toolkit-sui';

import { useWatch } from 'react-hook-form';

import { readOnlyFieldTypographyProps } from '../../../components/PropertyGrid/fields/consts.ts';
import { PropertyGridSectionProps } from '../../../components/PropertyGrid/types.ts';
import { selectCompAdjustments } from '../../../redux/features/selectors/adjustmentSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';

const Separator = () => (
  <Flex width="100%" height="1px" gridColumn="1 / -1" backgroundColor="textPrimary" />
);

export const AdjustmentsGridAdjustedSPSection = ({
  columnIndex,
  fieldTypes,
  control,
}: PropertyGridSectionProps) => {
  const propertyId = useWatch({
    name: `columns.${columnIndex}.propertyId`,
    control,
  });

  const { adjustedSalePrice, grossAdjustmentPct, netAdjustment, netAdjustmentPct } =
    useAppSelector(selectCompAdjustments)[propertyId] ?? {};

  const showLabels = fieldTypes.includes('label');
  const showValues =
    fieldTypes.includes('readOnlyValue') || fieldTypes.includes('readOnlyArvValue');
  const showReadOnlyUnitRate = fieldTypes.includes('readOnlyUnitRate');

  const typographyProps: TypographyProps = {
    ...readOnlyFieldTypographyProps,
    __dangerDoNotUseSx: {
      ...readOnlyFieldTypographyProps.__dangerDoNotUseSx,
      gridColumn: showLabels ? '2 / -1' : '1 / -1',
    },
  };

  return (
    <>
      <Separator />
      {showLabels && <Typography {...readOnlyFieldTypographyProps}>Net Adj. Total</Typography>}
      {showValues && (
        <Typography
          {...typographyProps}
          color={netAdjustment?.adjustment?.getDisplayColor() as ProductColor | undefined}
          textAlign="right"
        >
          {netAdjustment?.adjustment?.toString(true) ?? '-'}
        </Typography>
      )}
      {showReadOnlyUnitRate && <Typography {...typographyProps}>-</Typography>}
      {showLabels && <Typography {...readOnlyFieldTypographyProps}>Net Adj. %</Typography>}
      {showValues && (
        <Typography {...typographyProps} textAlign="right">
          {netAdjustmentPct?.value ?? '-'}
        </Typography>
      )}
      {showReadOnlyUnitRate && <Typography {...typographyProps}>-</Typography>}
      {showLabels && <Typography {...readOnlyFieldTypographyProps}>Gross Adj. %</Typography>}
      {showValues && (
        <Typography {...typographyProps} textAlign="right">
          {grossAdjustmentPct?.value ?? '-'}
        </Typography>
      )}
      {showReadOnlyUnitRate && <Typography {...typographyProps}>-</Typography>}
      <Separator />
      {showLabels && <Typography {...readOnlyFieldTypographyProps}>Adjusted SP</Typography>}
      {showValues && (
        <Typography
          {...typographyProps}
          color={adjustedSalePrice?.adjustment?.getDisplayColor() as ProductColor | undefined}
          textAlign="right"
        >
          {adjustedSalePrice?.value ?? '-'}
        </Typography>
      )}
      {showReadOnlyUnitRate && <Typography {...typographyProps}>-</Typography>}
    </>
  );
};
